

exports.__esModule = true;
exports.$LandingRoute = undefined;

require('squid/index');

require('xo-models/src/checkout/index');

require('xo-models/src/shoppingcart/index');

var _squid = require('squid');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {

    path: 'landing',

    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },

    auth: false,
    resolve: {

        action: function action($state, $populate, $ShoppingCartModel) {
            if (_angular.$rootScope.isOpenButton) {
                _logger.$logger.info('open_button_start_flow');
                return 'checkout.openButton';
            } else {
                return 'checkout.shoppingCart';
            }
        }
    }

});

angular.value("$LandingRoute", $LandingRoute);
_squid.$ComponentRoute;

_angular.$rootScope;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/route.js
// module id = ./pages/xo-landing/route.js
// module chunks = 1